import React, { useState } from 'react';
import { Div, Dropdown } from '@pinpoint/design-kit';
import { capitalCase } from 'src/functions';

function DropdownCell({ DivProps, menuValues, inputPath, inputValue, onChange }) {
	const [isOpen, setIsOpen] = useState(false);
	return (
		<Div align="center" d="flex" justify="end" m="0.5px" minH="20px" rounded="sm" {...DivProps}>
			<Dropdown
				maxW="8rem"
				p={{ x: '0.5rem', y: '1px' }}
				h="1rem"
				isOpen={isOpen}
				onClick={() => setIsOpen(!isOpen)}
				onSelect={(index) => {
					onChange(inputPath, menuValues[index]);
				}}
				menu={menuValues.map(capitalCase)}
				defaultValue={inputValue}
				rounded="0"
				style={{
					fontFamily: 'Inter',
				}}
				menuOptions={{
					pos: 'absolute',
					shadow: '4',
					minW: '100%',
					bg: 'white',
					style: {
						fontFamily: 'Inter',
					},
				}}
			/>
		</Div>
	);
}

export default DropdownCell;
